export default __webpack_public_path__ + "static/Ricardo-85c6a8999c44741704ad9293aa08d445.jpg";